import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Table, Row, Col, Button, notification } from "antd";
import { useTranslation } from "react-i18next";
import { useQuery } from "@apollo/client";

import { CATEGORY_COLUMNS } from "./constants";
import { FINANCE_CATEGORIES_QUERY } from "./categoryQueries";

const Container = styled.div`
  padding: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const Categories = ({ history }) => {
  const { t } = useTranslation();
  const { data, loading } = useQuery(FINANCE_CATEGORIES_QUERY, {
    error: notification.error,
  });

  return (
    <Container>
      <StyledRow>
        <FlexCol span={4} offset={20}>
          <Button
            type="primary"
            onClick={() => history.push("/finance/categories/new")}
          >
            {t("Add")}
          </Button>
        </FlexCol>
      </StyledRow>
      <Table
        rowKey="id"
        loading={loading}
        columns={CATEGORY_COLUMNS}
        dataSource={data ? data.financeCategories : []}
      />
    </Container>
  );
};

Categories.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Categories;
